import React, { useMemo } from 'react';
import { MAGICAL_BACKGROUND } from '../../constants/oracleConstants';
import './MagicalBackground.css';

const MagicalBackground = ({ intensity = 'medium', theme = 'basic' }) => {
  // Memoize particles to prevent re-creation on every render
  const particles = useMemo(() => 
    Array.from({ length: MAGICAL_BACKGROUND.PARTICLE_COUNT }, (_, index) => ({
      id: index,
      left: Math.random() * 100,
      animationDelay: Math.random() * MAGICAL_BACKGROUND.MAX_ANIMATION_DELAY,
      animationDuration: MAGICAL_BACKGROUND.PARTICLE_BASE_DURATION + Math.random() * MAGICAL_BACKGROUND.PARTICLE_DURATION_VARIANCE
    })), []
  );

  // Memoize orbs to prevent re-creation on every render
  const orbs = useMemo(() => 
    Array.from({ length: MAGICAL_BACKGROUND.ORB_COUNT }, (_, index) => ({
      id: index,
      left: 20 + index * 30,
      top: 20 + index * 20,
      animationDelay: index * 2
    })), []
  );

  return (
    <div className={`magical-background ${intensity} theme-${theme}`}>
      {/* Floating particles */}
      <div className="particles">
        {particles.map(particle => (
          <div
            key={particle.id}
            className="particle"
            style={{
              left: `${particle.left}%`,
              animationDelay: `${particle.animationDelay}s`,
              animationDuration: `${particle.animationDuration}s`
            }}
          />
        ))}
      </div>
      
      {/* Mystical orbs */}
      <div className="mystical-orbs">
        {orbs.map(orb => (
          <div
            key={orb.id}
            className="mystical-orb"
            style={{
              left: `${orb.left}%`,
              top: `${orb.top}%`,
              animationDelay: `${orb.animationDelay}s`
            }}
          />
        ))}
      </div>
      
      {/* Energy waves */}
      <div className="energy-waves">
        <div className="wave wave-1" />
        <div className="wave wave-2" />
        <div className="wave wave-3" />
      </div>
    </div>
  );
};

export default MagicalBackground;